import type { Rating } from '../types';

const OPTIONS: { val: Rating; emoji: string; aria: string }[] = [
  { val: 'up', emoji: '👍', aria: 'up' },
  { val: 'meh', emoji: '😐', aria: 'meh' },
  { val: 'down', emoji: '👎', aria: 'down' },
];

export function RatingButtons(props: {
  value: Rating | null;
  onChange: (r: Rating) => void;
}) {
  return (
    <span style={{ display: 'inline-flex', gap: '3px' }}>
      {OPTIONS.map(o => (
        <button
          key={o.val}
          aria-label={o.aria}
          aria-pressed={props.value === o.val}
          onClick={() => props.onChange(o.val)}
          style={{
            width: 28, height: 28,
            border: 'none',
            background: props.value === o.val ? 'var(--pink-tint)' : 'transparent',
            borderRadius: 8, fontSize: 14,
            opacity: props.value === o.val ? 1 : 0.45,
          }}
        >
          {o.emoji}
        </button>
      ))}
    </span>
  );
}
